import { useLayoutEffect } from 'react';

import { uiStore } from '@/stores/ui.store';

export const useChromelessSurface = (enabled = true) => {
  useLayoutEffect(() => {
    if (!enabled) return;
    uiStore.enterChromeless();
    return () => uiStore.leaveChromeless();
  }, [enabled]);
};
